var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82997 11.0001L10.7064 8.11555C11.0952 7.72576 11.0947 7.0948 10.7055 6.70555C10.3158 6.31592 9.68411 6.31592 9.29448 6.70555L4.70708 11.293C4.31655 11.6835 4.31655 12.3166 4.70708 12.7072L9.29448 17.2946C9.68411 17.6842 10.3158 17.6842 10.7055 17.2946C11.0947 16.9053 11.0952 16.2744 10.7064 15.8846L7.82997 13.0001H19C19.5523 13.0001 20 12.5523 20 12.0001C20 11.4478 19.5523 11.0001 19 11.0001H7.82997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9c31d1633b8493ae106cdaf7dfdcccff.svg";
export { ForwardRef as ReactComponent };